const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, id: string, block: ScrollLogicalPosition = 'start') => {
    const element = document.getElementById(id);
    if (element !== null) {
        e.preventDefault();
        element.scrollIntoView({ behavior: 'smooth', block: block });
    }
}

export { scrollToSection };
